module.exports = __webpack_public_path__ + "static/img/5.5c6c5d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/5.png
// module id = 2Pfm
// module chunks = 1